import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[host-component]',
  standalone: false
})
export class HostComponentDirective {
  constructor(public viewRef: ViewContainerRef) {
  }
}
